export default __webpack_public_path__ + "static/media/Vol3Issue2-Oct2022.9ea63132.png";